var $ = require('jquery');
var fitVids = require('fitvids');
var lottie = require("./libs/lottie.min.js");
var flickityHash = require("flickity-hash");
var Flickity = require("flickity");
var jQueryBridget = require("jquery-bridget");
var scrollMonitor = require("scrollmonitor");
var objectFitImages = require("object-fit-images");
var objectFitVideos = require("object-fit-videos");
var barba = require("@barba/core");


Flickity.setJQuery($);
jQueryBridget("flickity", Flickity, $);

require('./libs/gsap.min.js');

var easeIn = 'cubic-bezier(.41,1.04,.72,1.01)';
var mobileBP = window.matchMedia('(max-width: 768px)');

// lottie json object
let arrowJSON = require('./json/sfx-arrow.json');
let logoJSON = require('./json/sfx-logo.json');

// set homepageSlideTranstion to done to prevent next slide appearing before transtion is done
let homepageSlideTransition = false;

$(window).on("load", function () {
    init();
    initNav();
    animateNavLogo();
    // console.log($._data(window).events);

    if ($("body").hasClass('home')) {
        animateHome();
    }
})


function init() {

    initCarousel();
    initHomePage();


    initCaseStudyClasses();
    animateFooter();
    animateCarousel();
    animatePages();
    animatePageTitles();
    animateCaseStudy();
    animateBasicContent();
    addWYSIWYGArrow();
    calcPageIntroHeight();

    objectFitImages();
    objectFitVideos();

    if ($("body").hasClass('home')) {
        initHomepageScroll();
        animateHome();
    }

    if ($('body').hasClass('single')) {
        animateCaseStudyTitle();

        if ($('.case-study__hero-background').find('video').length > 0) {
            // $('.case-study__hero-background').find('video')[0].play();
            videoPlayPromiseCheck($('.case-study__hero-background').find('video')[0], 'play');
        }
    }

    $(window).on('resize', debounce(calcPageIntroHeight, 200));
}

function videoPlayPromiseCheck(ele, action) {
    var playPromise = ele.play();

    if (playPromise !== undefined) {
        playPromise.then(_ => {
                // Automatic playback started!
                // Show playing UI.
                // console.log('here');
                if (action == 'play') {
                    playPromise;
                }
                if (action == 'pause') {
                    // playPromise = ele.pause();
                }
            })
            .catch(error => {
                // Auto-play was prevented
                // Show paused UI.
                console.log(error);
            });
    }
}

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}

function initNav() {

    // toggle nav menu
    $('.menu-toggle__hamburger--box').on('click', function () {
        $(this).toggleClass('active');
        $('.site-header__nav').toggleClass('active');

        if ($(this).hasClass('active')) {
            animateNavMenu();
        }
    })

    // add/animate hover state underline on mouseenter
    $('.site-header .menu-item').each(function () {
        $(this).find('a').on('mouseenter', function () {

            debounce(animateIn($(this), 1000));
        });
    })

    function animateIn(ele) {
        let accent = $('<span class="menu-item__accent">');
        let aWidth = ele.width();
        accent.css({
            right: (ele.parent().width() + aWidth + 30) + 'px',
            width: aWidth,
        });
        accent.appendTo(ele.parent());
        gsap.to(accent, {
            duration: 0.4,
            right: 0,
        })
    }

    // remove/animate hover state underline on mouseleave
    $('.site-header .menu-item').each(function () {
        $(this).find('a').on('mouseleave', function () {
            let accent = $(this).siblings('.menu-item__accent');
            gsap.to(accent, {
                duration: 0.4,
                right: '-100%',
                onComplete: removeAccent,
                onCompleteParams: [accent]
            })
        })

        function removeAccent(ele) {
            ele.remove();
        }
    })

    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        if (!$('.site-header__nav').hasClass('active') && !$('body').hasClass('home')) {
            var st = $(this).scrollTop();
            if (st > lastScrollTop && st > 0) {
                // downscroll code
                $('.site-header').addClass('scrolling-down');
            } else {
                $('.site-header').removeClass('scrolling-down');
            }
            lastScrollTop = st;
            if (st > 0) {
                $('#site-header__logo').addClass('hide');
            } else {
                $('#site-header__logo').removeClass('hide');
            }
        }
    });

    var homeLastScrollTop = 0;
    $('.slides__slide--about-us').on('scroll', function () {

        var st = $(this).scrollTop();
        if (st > homeLastScrollTop && st > 0) {
            // downscroll code
            $('.site-header').addClass('scrolling-down');
        } else {
            $('.site-header').removeClass('scrolling-down');
        }
        homeLastScrollTop = st;

        if (st > 0) {
            $('#site-header__logo').addClass('hide');
        } else {
            $('#site-header__logo').removeClass('hide');
        }

    });
}

function initHomePage() {
    let firstSlide = $('.slides__slide').first();
    let aboutUs = scrollMonitor.create($('.slide-content__additional-content'));

    // activate first slide and play video if available
    firstSlide.addClass('active');
    if (firstSlide.find('video').length > 0) {
        // console.log('initHomePage videoPlayPromiseCheck');
        // firstSlide.find('video')[0].play();
        videoPlayPromiseCheck(firstSlide.find('video')[0], 'play');
    }

    // carousel controls
    $('.slide-controls__dot').each(function () {

        $(this).on('click', function () {

            let controlNum = $(this).attr('data-relative-slide');
            let unmatchedItems = [];
            let matchedItem;

            // cycle through the slides, if slide matched clicked dot number, set this slide in matchedItem var
            // else add this slide to the unmatchedItems array
            $('.slides__slide').each(function () {
                if ($(this).attr('data-slide') == controlNum) {
                    matchedItem = $(this);
                } else {
                    unmatchedItems.push($(this));
                }
            })

            matchedSlide(matchedItem, unmatchedItems);

        })
    })

    // clone footer and append to about us slide
    let footerContent = $('.site-footer .container').clone();
    $('.slides__slide--about-us').find('.slide-content__footer-content').append(footerContent);

    if ($("body").hasClass('home')) {
        setTimeout(() => {
            homepageSlideTransition = true
        }, 1500);
    }
}

function matchedSlide(matchedEle, unmatchedItems) {

    // set homepageSlideTranstion to done to prevent next slide appearing before transtion is done
    homepageSlideTransition = false;
    let matchedEleNum = matchedEle.attr('data-slide');

    // remove active dot class and add active class to corresponding dot
    $('.slide-controls__dot.active').removeClass('active');
    $('.slide-controls__dot').eq(matchedEleNum - 1).addClass('active');

    // handle all matched element classes and transitions
    $('.slides__slide.active').removeClass('active');
    matchedEle.addClass('active');

    // if active slide has video, play it
    if (matchedEle.find('video').length > 0) {
        let video = matchedEle.find('video')[0];
        // Show loading animation.
        // console.log('matchedSlide videoPlayPromiseCheck');
        videoPlayPromiseCheck(video, 'play');
    }

    if (matchedEle.hasClass('slides__slide--about-us')) {
        animateLargeTitles($('.slide-content__title h1'), $('.slide-content__title h1').find('div'));

        // only run this page animation once. not on click.
        let span = $('.slide-content__additional-content h1').find('span');
        let h1 = $('.slide-content__additional-content h1');
        animateLargeTitles(h1, span);
        animateHomeAbout(span);

    } else {
        animateLargeTitles(matchedEle, matchedEle.find('.slides__slide-performer div'));
    }

    // handle all unmatched items
    $(unmatchedItems).each(function () {
        // reset performer styles to animate again
        $(this).find('.slides__slide-performer div').each(function () {
            $(this).attr('style', '');
        })

        // restart video
        if ($(this).find('video').length > 0) {
            let video = $(this).find('video')[0];
            // video.pause();
            videoPlayPromiseCheck(video, 'pause');
            setTimeout(function () {
                video.currentTime = 0;
            }, 550);
        }
    })
    setTimeout(() => {
        // set homepageSlideTranstion to done to prevent next slide appearing before transtion is done
        homepageSlideTransition = true;
    }, 1500);
}

function initHomepageScroll() {
    let y = 0;
    let direction;


    // scroll
    $(window).on("wheel", function (e) {
        // direction
        if (event.deltaY >= 0) {
            direction = 'down';
        } else {
            direction = 'up';
        }
        // console.log(e, direction);

        // if on about us slide. If scroll up and not at the top of page, do nothing.
        // if at the top of the page go to previous slide.
        // if not on about us slide, scroll through pages normally.

        if ($('.slides__slide--about-us').hasClass('active')) {
            if ($('.slides__slide--about-us').scrollTop() > 0) {
                return;
            } else {
                moveSlides(e, direction)
            }
        } else {
            moveSlides(e, direction)
        }
    })

    //touch
    var touchStartValue;
    $(document).bind('touchstart', function (e) {
        // grab clientY value at touch start
        touchStartValue = e.originalEvent.touches[0].clientY;
    });

    $(document).bind('touchend', function (e) {
        // grab clientY at touch end
        var touchEndValue = e.originalEvent.changedTouches[0].clientY;

        // determine direction of touch event
        if (touchStartValue > touchEndValue + 100) {
            direction = 'down';
        } else if (touchStartValue < touchEndValue - 100) {
            direction = 'up';
        }

        // if on about us slide. If scroll up and not at the top of page, do nothing.
        // if at the top of the page go to previous slide.
        // if not on about us slide, scroll through pages normally.

        if ($('.slides__slide--about-us').hasClass('active')) {
            if ($('.slides__slide--about-us').scrollTop() > 0) {
                return;
            } else {
                moveSlides(e, direction);
            }
        } else {
            moveSlides(e, direction);
        }
    });

    function moveSlides(e, direction) {

        let slides = $('.slides__slide');
        let unmatchedItems;
        let matchedItem;
        let currentSlide = $('.slides__slide.active');

        // if direction is down, go to next slide and filter out other slides
        if (direction == 'down') {
            matchedItem = currentSlide.next();
            unmatchedItems = slides.filter(slide => slide + 1 != matchedItem.attr('data-slide'));
        } else {
            // if direction is up go to previous slide and filter out other slides
            matchedItem = currentSlide.prev();
            unmatchedItems = slides.filter(slide => slide + 1 != matchedItem.attr('data-slide'));
        }

        // set homepageSlideTranstion to done to prevent next slide appearing before transtion is done
        if (homepageSlideTransition == true && matchedItem.length > 0) {
            matchedSlide(matchedItem, unmatchedItems);
        }
        // console.log(homepageSlideTransition);
    }
}

function animateHome() {

    if ($('body').hasClass('home')) {

        // animate control dots
        let dots = $('.home__slide-controls').find('.slide-controls__dot');
        gsap.to(dots, {
            top: 0,
            duration: 0.8,
            stagger: 0.2,
            ease: "back.out(1.7)",
            delay: 0.5,
        })

        $('.slides__slide').each(function (index, ele) {
            let arrowContainer = $(this).find(".arrow-container");
            let performer = $(this).find('.slides__slide-performer');
            let aboutUsTitle = $(this).find('.slide-content__title h1');

            // only split text once
            if (aboutUsTitle.find('div').length == 0) {
                let splitAboutUs = new SplitText(aboutUsTitle, {
                    type: 'words',
                    wordsClass: 'split-large-text',
                })
            }

            // only split text once
            // if (performer.find('div').length == 0) {
            //     let splitPerformer = new SplitText(performer, {
            //         type: 'lines',
            //         linesClass: 'split-large-text',
            //     });
            // }

            if (arrowContainer.length > 0) {
                if (!$(this).hasClass('slides__slide--about-us')) {
                    animateArrow(arrowContainer, 'calc(100% - 6.25em)');
                }
            }

            //first slide on page load
            if (index == 0) {
                animateLargeTitles($(this), $(this).find('.slides__slide-performer div'));
            }
        })
    }
}

function animateCaseStudy() {

    // content with visual section
    $('.content-with-visual').each(function () {
        let contentPosition = '';
        let _this = $(this);
        let content = _this.find('.content-with-visual__content');
        let media = _this.find('.content-with-visual__media');

        let offset = -200;
        if (mobileBP.matches) {
            offset = 0;
        }

        let contentViewport = scrollMonitor.create($(this), offset);
        contentViewport.enterViewport(function () {

            if (_this.find('video').length > 0) {
                // _this.find('video')[0].play();
                videoPlayPromiseCheck(_this.find('video')[0], 'play');
            }

            let tl = gsap.timeline();
            tl.add(function () {
                content.addClass('animate-in');
            })
            tl.from(media, {
                opacity: 0,
                duration: 1,
            }, '-=0.2')
            tl.to(content.children(), {
                top: 0,
                opacity: 1,
                stagger: 0.3,
                duration: 0.5,
                ease: easeIn,
            }, '-=1');
        })
    })
}

function addWYSIWYGArrow() {
    $('.wysiwyg-content').each(function () {
        // if the arrow fromat was selected in the wysiwyg editor grab it
        let arrowContainer = $(this).find('.arrow-content-container');

        if (arrowContainer.length > 0) {
            arrowContainer.find('a').append('<span class="arrow-container">');

            // add arrow and animate it
            let arrow = arrowContainer.find('.arrow-container');
            animateArrow(arrow, 'calc(100% - 1.66667em)');
        }
    })
}



function animateHomeAbout(ele) {

    $('.slides__slide-background--about-us').addClass('animate-in');
    $('.slide-content__cta').addClass('animate-in');

    // adds float classes to text at bottom of last slide on the home page
    let timer = 0;
    ele.each(function () {
        staggerFloat($(this));
    })

    function staggerFloat(ele) {
        timer += 750;
        setTimeout(function () {
            if (ele.hasClass('align-left')) {
                ele.addClass('animate-right');
            } else {
                ele.addClass('animate-left');
            }
        }, timer);
    }

    // CTA animation
    $('.slide-content__cta').addClass('animate-in');
    let arrowContainer = $('.slide-content__cta').find('.arrow-container');
    animateArrow(arrowContainer, '90%', 1.25);
}

function animateLargeTitles(parent, splitArray) {

    let performerTitle = parent.find('.slides__slide-title p');
    let aboutUsTitle = parent.find('div');


    if (performerTitle.length > 0) {
        performerTitle.attr('style', '');
    } else if (aboutUsTitle.length > 0) {
        aboutUsTitle.each(function () {
            $(this).attr('style', '');
        })
    }

    var tl = gsap.timeline();
    if (splitArray.length > 0) {
        tl.to(splitArray, {
            color: '#FFF',
            top: 0,
            left: 0,
            opacity: 1,
            delay: 0.2,
            stagger: 0.2,
            duration: 0.3,
            ease: easeIn,
        })
    }
    tl.to(performerTitle, {
        top: 0,
        duration: 0.4,
    })
}

//animate logo with lottie
function animateNavLogo() {

    // place lottie initalized SVG inside a tag
    let siteLogo = $('#site-header__logo').find('a');

    var logo = lottie.loadAnimation({
        container: siteLogo[0], // the dom element that will contain the animation
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: logoJSON, // the path to the animation json
    });

    logo.play();
}

// animate arrow with lottie
function animateArrow(arrowContainer, animationValue, delay = 1) {
    // if an arrow svg exists, remove it
    if (arrowContainer.find('svg').length > 0) {
        arrowContainer.find('svg').remove();
    }

    // add arrow svg
    var arrow = lottie.loadAnimation({
        container: arrowContainer[0], // the dom element that will contain the animation
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: arrowJSON, // the path to the animation json
    });

    if (animationValue != null) {
        gsap.to(arrowContainer, {
            left: animationValue,
            delay: delay,
            duration: 0.5,
            ease: easeIn,
        })
    }
    setTimeout(function () {
        arrow.play();
    }, delay);
}

function animateNavMenu() {
    let logo = $('.site-header__nav-logo');
    let menuItems = $('.site-header__nav').find('.menu-item');
    gsap.from(logo, {
        top: '-45px',
        opacity: 0,
        duration: 0.4,
        delay: 0.4,
    })
    gsap.from(menuItems, {
        top: '-250px',
        scale: 3.5,
        right: '-250px',
        duration: 0.6,
        stagger: 0.1,
        ease: easeIn,
    })
    gsap.from('.site-header__socials', {
        duration: 0.4,
        delay: 0.8,
        opacity: 0,
        ease: easeIn,
    })
}

function animateFooter() {
    let footer;
    if ($('body').hasClass('home')) {

        // since scrolling is disabled on all slides except about us, scroll monitor wont register in view.
        // so well calculate manually when it is in view.
        footer = $('.slide-content__footer-content');
        $('.slides__slide--about-us').on('scroll', function () {
            let rect = footer[0].getBoundingClientRect();
            if ($(window).height() > (rect.top - 150)) {
                runAnimation();
            }
        })
    } else {

        // use scroll monitor for normal footer animations
        footer = $('.site-footer');
        let footerViewport = scrollMonitor.create(footer);
        footerViewport.enterViewport(function () {
            runAnimation();
        })
    }

    function runAnimation() {
        var tl = gsap.timeline();
        tl.add(() => {
                footer.find(".footer__logo").addClass('animate-in');
            })
            .to(footer.find('.menu-item a'), {
                top: 0,
                opacity: 1,
                stagger: 0.15,
                rotate: 0,
                duration: 0.4,
            }, '-=0.05')
            .to($('.footer__socials').children(), {
                top: 0,
                opacity: 1,
                stagger: 0.2,
                duration: 0.3,
                rotate: 0,
            }, '-=0.5');
    }
}

function initCarousel() {
    let cellAlignment = 'left';

    if (mobileBP.matches) {
        cellAlignment = 'center'
    }

    $('.carousel-container').each(function (inx, ele) {
        let startIndex = 0;
        let _this = ele;
        let carouselDots = false;
        if ($('body').hasClass('page-template-page-our-work') && $(_this).hasClass('gallery__container') || $('body').hasClass('single') && $(_this).hasClass('gallery__container')) {

            // randomize carousel elements
            for (var i = _this.children.length; i >= 0; i--) {
                $(_this).append(_this.children[Math.random() * i | 0]);
            }
            carouselDots = true;
        }

        let $carousel = $(this).flickity({
            pageDots: carouselDots,
            prevNextButtons: false,
            cellAlign: cellAlignment,
            initialIndex: startIndex,
            wrapAround: true,
            watchCSS: true,
        })

        var data = $carousel.data('flickity');

        // featured work carousel
        if ($(this).hasClass('featured-case-studies__cases')) {
            let parent = $(this).closest('.featured-case-studies');
            let featuredTitle = parent.find('.featured-case-studies__feature-title');
            let performer = parent.find('.featured-case-studies__performer a');
            let summary = parent.find('.featured-case-studies__summary');
            let link = $(this).siblings('.featured-case-studies__content').find('.arrow-container');

            let eventChange = false;
            $(this).find('video').each(function (index, ele) {
                // ele.play();
                videoPlayPromiseCheck(ele, 'play');
            })

            updateInfo();
            animateFeaturedInfo();

            // desktop arrow
            link.each(function () {
                animateArrow($(this), '100%', 1.125);
            })

            // mobile arrows
            $('.featured-case-studies__case-data').find('.arrow-container').each(function () {
                animateArrow($(this), '100%', 1.125);
            })

            let splitFeaturedTitle = new SplitText(featuredTitle, {
                type: 'word',
                wordsClass: 'split-large-text',
            });

            animateLargeTitles(featuredTitle, featuredTitle.children());

            // trigger when dragging moves and slider move
            $carousel.on('change.flickity', function (event, pointer) {
                eventChange = true;
                animateFeaturedInfo();
                videoLogic(data.selectedElement);

            })

            function videoLogic(ele) {
                // pause all other videos
                $(".featured-case-studies__case").each(function () {
                    if ($(this).find('video').length > 0) {
                        // $(this).find('video')[0].pause();
                        videoPlayPromiseCheck($(this).find('video')[0], 'play');
                    }
                })

                // if current element has video, play it
                if ($(ele).find('video').length > 0) {
                    $(ele).find('video')[0].currentTime = 0;
                    // $(ele).find('video')[0].play();
                    videoPlayPromiseCheck($(ele).find('video')[0], 'play');
                }
            }

            function animateFeaturedInfo() {
                // if featured info is populated from a drag event, animate exisiting performer out
                if (eventChange) {
                    gsap.to(summary, {
                        opacity: 0,
                        duration: 0.2,
                        onComplete: updateAndAnimateIn,
                        onCompleteParams: [0.4]
                    })

                    gsap.to(performer, {
                        top: '-40px',
                        duration: 0.4,
                        onComplete: updateAndAnimateIn,
                        onCompleteParams: [0.4]
                    })
                } else {
                    // if featured listing is populated from a page load, only animate performer in
                    updateAndAnimateIn(1);
                }

                function updateAndAnimateIn(delay) {
                    // update performer and summary with active slide data
                    updateInfo();

                    // animate the new elements back into view
                    summary.css({
                        top: '40px',
                    })

                    gsap.to(performer, {
                        top: 0,
                        delay: delay,
                        duration: 0.4,
                    })
                    gsap.to(summary, {
                        top: 0,
                        opacity: 1,
                        delay: delay + 0.2,
                        duration: 0.5,
                    })
                }
            }

            function updateInfo() {
                // grab the visible slide data and place it in the info overlay
                let currentPerformer = $('.featured-case-studies__case.is-selected').find('.performer').text();
                let currentSummary = $('.featured-case-studies__case.is-selected').find('.summary').html();
                let currentLink = $('.featured-case-studies__case.is-selected').find('.link').attr('href');

                performer.text(currentPerformer);
                performer.attr('href', currentLink);

                if (currentSummary) {
                    summary.html(currentSummary);
                }

                link.attr('href', currentLink);
            }
        }
    })
}

function animatePageTitles() {

    // animate page title ( red text )
    if ($('.page-title').length > 0) {
        $('.page-title').addClass('animate-down');
    }

    // animate subtitle ( large white text )
    if ($('.page-subtitle').length > 0) {
        let subtitle = $('.page-subtitle');
        new SplitText(subtitle, {
            type: 'words',
            wordsClass: 'split-large-text',
        })
        $(".page-subtitle").css('opacity', 1);
        animateLargeTitles(subtitle, subtitle.find('div'));
    }

    // animate intro content and its body copy
    if ($(".page-intro__content").length > 0) {
        $('.page-intro__content').addClass('animate-in');
        gsap.to($(".page-intro__content").children(), {
            top: 0,
            opacity: 1,
            delay: 0.5,
            stagger: 0.2,
            duration: 0.4,
        })
    }
}

function animatePages() {

    if (
        $('body').hasClass('page-template-page-about-us') ||
        $('body').hasClass('page-template-default') ||
        $('body').hasClass('error404') ||
        $('body').hasClass('wpautoterms_page-template-page-legal')
    ) {
        // about us template content animations

        // content
        $('.page-content').find('.content').addClass('animate-in');
        gsap.to($('.page-content .content').children(), {
            top: 0,
            opacity: 1,
            delay: 0.5,
            duration: 0.4,
            stagger: 0.2,
        })

        // sidebar
        $('.page-content').find('.sidebar').addClass('animate-in');
        gsap.to($('.page-content .sidebar__content').children(), {
            top: 0,
            opacity: 1,
            delay: 0.5,
            duration: 0.4,
            stagger: 0.2,
        })

        // logos
        let logosViewport = scrollMonitor.create($('.logos__logo'), -200);
        logosViewport.enterViewport(function () {
            gsap.to($('.logos__logo'), {
                top: 0,
                opacity: 1,
                duration: 0.3,
                ease: easeIn,
                stagger: 0.2,
            })
        })

        // full width media
        new SplitText($('.full-width-media__title'), {
            type: 'word'
        })
        let fullMediaViewport = scrollMonitor.create($('.full-width-media__media'), -200);
        fullMediaViewport.enterViewport(function () {
            $('.full-width-media .container').addClass('animate-in');
            $('.full-width-media__media').addClass('animate-in');
            gsap.to($('.full-width-media__title div'), {
                left: 0,
                opacity: 1,
                stagger: -0.3,
                delay: 0.6,
                duration: 0.8,
            })

        })
        let fullContent = scrollMonitor.create($('.full-width-media__content'), -200);
        fullContent.enterViewport(function () {
            $('.full-width-media__content').addClass('animate-in');
            gsap.to($('.full-width-media__wysiwyg-content').children(), {
                top: 0,
                opacity: 1,
                stagger: 0.3,
                duration: 0.5,
                delay: 0.4,
            })
        })

        //locations
        let locationsViewport = scrollMonitor.create($('.locations'), -200);
        locationsViewport.enterViewport(function () {
            $(".locations__title h1").addClass('animate-in');
            $(".locations__map").addClass('animate-in');
            gsap.to($('.locations__location'), {
                opacity: 1,
                stagger: 0.4,
                duration: 0.8,
            })
        })

    } else if ($('body').hasClass('page-template-page-careers')) {

        // careers template content animations
        $('.page-intro__media').addClass('animate-in');

        let careersContentViewport = scrollMonitor.create($('.page-content__content-container'), -200);
        careersContentViewport.enterViewport(function () {
            $('.page-content__content-container').addClass('animate-in');
            gsap.to($('.page-content__content').children(), {
                top: 0,
                opacity: 1,
                stagger: 0.2,
                duration: 0.4,
                delay: 0.4,
            })
            gsap.to($('.page-content__visuals').children(), {
                right: 0,
                opacity: 1,
                stagger: 0.2,
                duration: 0.4,
            })
        })

    } else if ($('body').hasClass('page-template-page-contact')) {

        // contact template content animations
        $('.page-intro__locations').addClass('animate-in');
        gsap.to($('.page-intro__locations').children(), {
            top: 0,
            opacity: 1,
            stagger: 0.2,
            duration: 0.4,
            delay: 0.4,
        })
        gsap.to($('.page-intro__contact').children(), {
            top: 0,
            opacity: 1,
            stagger: 0.2,
            duration: 0.4,
            delay: 0.2,
        })
        let contactMedia = scrollMonitor.create($('.page-intro__media'), -200);
        contactMedia.enterViewport(function () {
            $('.page-intro__media').addClass('animate-in');
        })
    }
}

function animateCarousel() {
    $('.carousel-container').each(function () {
        let _this = $(this)
        if (_this.hasClass('gallery__container')) {
            let title = _this.siblings('.gallery__section-title');
            let titleSplit = new SplitText(title, {
                type: 'lines',
                linesClass: 'split-large-text',
            });

            animateLargeTitles(title, title.find('div'));
        }
        let carouselViewport = scrollMonitor.create(_this, -100);
        carouselViewport.enterViewport(function () {
            gsap.to(_this.find('.carousel-item'), {
                x: 0,
                duration: 1,
                opacity: 1,
                stagger: 0.2,
                ease: easeIn,
            })
        })
    })
}

function animateBasicContent() {
    $('.basic-content').each(function () {
        let _this = $(this);
        let basicContentViewport = scrollMonitor.create(_this, -200);
        basicContentViewport.enterViewport(function () {
            _this.addClass('animate-in');
            let content = _this.find('.basic-content__wysiwyg-content').children();
            gsap.to(content, {
                top: 0,
                opacity: 1,
                stagger: 0.3,
                ease: easeIn,
                duration: 0.5,
                delay: 0.4,
            })
        })
    })
}

function calcPageIntroHeight() {
    let intro = $('.page-intro__content');
    if (intro.length > 0) {

        let introHeight = intro.outerHeight(true);
        let parentHeight = $('.page-intro').height();
        let total = parentHeight + (introHeight - parentHeight);
        $(".page-intro").css('min-height', 'calc(' + total + 'px + 14em)');
    }
}

function animateCaseStudyTitle() {
    $(".case-study__our-work").addClass('animate-down');
    $(".case-study__content-title").addClass('animate-up');

    $('.case-study__arrow').on('click', function () {
        $('html,body').animate({
            scrollTop: $(this).parents('.case-study__hero').next().offset().top - 200,
        }, 1000);
    })
}

function initCaseStudyClasses() {
    $('.content-with-visual').each(function () {

        // if content with visuals next element is gallery AND galleries next element is content with visuals, add appropriate classes
        if ($(this).next().hasClass('gallery') && $(this).next().next().hasClass('content-with-visual')) {
            $(this).addClass('before-gallery');
            $(this).next().addClass('gallery--sandwich');
            $(this).next().next().addClass('after-gallery');

            calcHeight();

            $(window).on('resize', debounce(calcHeight, 200));

            function calcHeight() {

                // calcualate first content with visuals content box height
                let beforeContent = $('.before-gallery').find('.content-with-visual__content');

                //content container's top and bottom padding = 160
                let beforeContentHeight = 160;

                // calc children height
                beforeContent.children().each(function () {
                    beforeContentHeight += $(this).outerHeight(true);
                })

                let totalHeight = $('.gallery--sandwich').outerHeight() + beforeContentHeight;

                // assign height to content container
                beforeContent.css({
                    'height': totalHeight + 'px',
                })

                // assign height to parent container ( page-section--content-with-visual )
                beforeContent.closest('.before-gallery').css({
                    'height': totalHeight + 'px',
                });
            }
        }
    })
}

// barba hook order
// 1	before          - Before everything
// 2	beforeLeave     - Before leave transition
// 3	leave           - Current page leave transition
// 4	afterLeave      - After leave transition
// 5	beforeEnter     - Before enter transition and after adding next container
// 6	enter           - Next page enter transition
// 7	afterEnter      - After enter transition
// 8	after           - After everything

// global hooks
barba.hooks.before((data) => {
    if ($('body').hasClass('home')) {
        homepageSlideTransition = false;
    }
})
let currentVideoTime;
barba.hooks.beforeLeave((data) => {
    $('.menu-toggle__hamburger--box.active').removeClass('active');
    $('.site-header__nav.active').removeClass('active');
})

barba.hooks.afterLeave((data) => {
    // Set <body> classes for "next" page
    var nextHtml = data.next.html;
    var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml)
    var bodyClasses = $(response).filter('notbody').attr('class')
    $("body").attr("class", bodyClasses);
});

barba.hooks.afterEnter((data) => {
    // reset to top of the page
    $(document).ready(function () {
        if (!$("body").hasClass('home')) {
            $(this).scrollTop(0);
        } else {
            homepageSlideTransition = false;
        }
    });
})

barba.hooks.after((data) => {
    init();
    let newPathName = window.location.pathname;
    let newTitleName = window.document.title;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        event: 'pageviewCustomEvent',
        pagePath: newPathName,
        pageTitle: newTitleName,
    })
})

barba.init({
    debug: false,
    transitions: [{
        name: 'default',
        to: 'page',
        // sync: true,
        leave({
            current,
            next,
            trigger
        }) {

            const done = this.async();
            gsap.to(current.container, 0.5, {
                opacity: 0,
                onComplete: done,
            })
        },
        enter({
            current,
            next,
            trigger
        }) {

            const done = this.async();
            gsap.to(next.container, 0.2, {
                opacity: 1,
                onComplete: done,
            })
        },
        after({
            current,
            next,
            trigger
        }) {

        }
    }, {
        name: 'case-study',
        from: {
            custom: ({
                trigger
            }) => {
                return trigger.classList && (trigger.classList.contains('case-study-link') || trigger.classList.contains('slides__slide-performer--link'));
            }
        },
        sync: true,
        // before({
        //     current,
        //     next,
        //     trigger
        // }) {
        //     $(current.container).addClass('ready-transition');
        // },
        beforeLeave({
            current,
            next,
            trigger
        }) {
            const done = this.async();
            if ($(current.container).find('.slides__slide.active video').length > 0) {
                currentVideoTime = $(current.container).find('.slides__slide.active video')[0].currentTime;
            }
            gsap.to($(current.container).find('.arrow-container'), 0.4, {
                rotate: '90deg',
                opacity: function () {
                    if (mobileBP.matches) {
                        return 0;
                    } else {
                        return 1;
                    }
                },
                onComplete: done,
            })
        },
        leave({
            current,
            next,
            trigger
        }) {
            const done = this.async();
            gsap.to($(current.container).find('.home__slide-controls'), 0.2, {
                opacity: 0,
            })
            gsap.to($(next.container).find('.case-study__arrow'), 1, {
                opacity: 1,
            })
            gsap.to(current.container, 1, {
                opacity: 0,
                onComplete: done,
            })
        },
        afterLeave({
            current,
            next,
            trigger
        }) {

        },
        beforeEnter({
            current,
            next,
            trigger
        }) {
            // let done = this.async()
            let video = $(next.container).find('.case-study__hero-background video');
            if (video.length > 0) {
                video[0].currentTime = currentVideoTime;
                videoPlayPromiseCheck(video[0], 'play');
                // done();
            }
        },
        enter({
            current,
            next,
            trigger
        }) {
            const done = this.async();
            gsap.from(next.container, 1, {
                opacity: 0,
                onComplete: done,
            })
        },
        after(data) {
            animateCaseStudyTitle();

        }
    }]
})